import ic_calendar from './ic_calendar.svg';
import ic_policy_holder from './ic_policy_holder.svg';
import ic_policy_term from './ic_policy_term.svg';
import ic_policy from './ic_policy.svg';
import ic_purchase_date from './ic_purchase_date.svg';
import ic_renewal_date from './ic_renewal_date.svg';
import ic_start_date from './ic_start_date.svg';
import ic_status from './ic_status.svg';
import ic_tier from './ic_tier.svg';
import ic_user_id from './ic_user_id.svg';
import ic_users from './ic_users.svg';
import ic_birthdate from './ic_birthdate.svg';
import ic_email from './ic_email.svg';
import ic_phone from './ic_phone.svg';
import ic_postcode from './ic_postcode.svg';
import ic_user from './ic_user.svg';
import ic_acorn from './ic_acorn.svg';
import ic_car_side from './ic_car_side.svg';
import ic_signup from './ic_signup.svg';
import ic_trips from './ic_trips.svg';
import ic_permission_fitness from './ic_permission_fitness.svg';
import ic_permission_gps from './ic_permission_gps.svg';
import ic_permission_jailbreak from './ic_permission_jailbreak.svg';
import ic_permission_low_power from './ic_permission_low_power.svg';
import ic_permission_motion from './ic_permission_motion.svg';
import ic_permission_precise from './ic_permission_precise.svg';
import ic_permission_rooted_android from './ic_permission_rooted_android.svg';
import ic_remaining_credit_balance from './ic_remaining_credit_balance.svg';
import ic_amazon_credit_balance from './ic_amazon_credit_balance.svg';
import ic_total_earned_amazon from './ic_total_earned_amazon.svg';
import ic_pound from './ic_pound.svg';
import ic_amazon_voucher from './ic_amazon_voucher.svg';
import ic_png_file from './ic_png_file.svg';
import ic_edit from './ic_edit.svg';
import ic_car from './ic_car.svg';
import ic_insight from './ic_insight.svg';
import ic_reward from './ic_reward.svg';
import ic_dclub from './ic_dclub.svg';
import ic_faq from './ic_faq.svg';
import ic_question from './ic_question.svg';
import ic_answer from './ic_answer.svg';
import ic_add_fill from './ic_add_fill.svg';
import ic_language from './ic_language.svg';
import ic_delete from '../ic_delete.svg';

export const Icons = {
  // profile
  ic_acorn,
  ic_car_side,
  ic_signup,
  ic_trips,
  ic_birthdate,
  ic_email,
  ic_phone,
  ic_postcode,
  ic_user,

  // policy
  ic_calendar,
  ic_policy_holder,
  ic_policy_term,
  ic_policy,
  ic_purchase_date,
  ic_renewal_date,
  ic_start_date,
  ic_status,

  // club
  ic_tier,
  ic_user_id,
  ic_users,

  // permissions
  ic_permission_fitness,
  ic_permission_gps,
  ic_permission_jailbreak,
  ic_permission_low_power,
  ic_permission_motion,
  ic_permission_precise,
  ic_permission_rooted_android,

  // transactions
  ic_remaining_credit_balance,
  ic_amazon_credit_balance,
  ic_total_earned_amazon,
  ic_pound,
  ic_amazon_voucher,

  ic_png_file,
  ic_edit,
  ic_delete,

  // features
  ic_car,
  ic_insight,
  ic_reward,
  ic_dclub,
  ic_faq,
  ic_question,
  ic_answer,
  ic_add_fill,
  ic_language,
  ic_referral: ic_users, // Use users icon for referral
};
